export const CART_BASE_URL = process.env.REACT_APP_CART_BASE_URL;
export const PASS_BASE_URL= process.env.REACT_APP_PASS_BASE_URL;
export const ORDER_BASE_URL = process.env.REACT_APP_ORDER_BASE_URL;
export const REPORT_BASE_URL= process.env.REACT_APP_REPORT_BASE_URL;